module.exports = __webpack_public_path__ + "assets/img/title-983fbd75.png";